import * as React from "react"
import * as AlertDialogPrimitive from "@radix-ui/react-alert-dialog"

const AlertDialog = AlertDialogPrimitive.Root

const AlertDialogTrigger = AlertDialogPrimitive.Trigger

const AlertDialogPortal = AlertDialogPrimitive.Portal

const AlertDialogOverlay = (
  props: React.ComponentProps<typeof AlertDialogPrimitive.Overlay>,
) => <AlertDialogPrimitive.Overlay {...props} />
AlertDialogOverlay.displayName = AlertDialogPrimitive.Overlay.displayName

const AlertDialogContent = (
  props: React.ComponentProps<typeof AlertDialogPrimitive.Content>,
) => <AlertDialogPrimitive.Content {...props} />
AlertDialogContent.displayName = AlertDialogPrimitive.Content.displayName

const AlertDialogHeader = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...props} />
)
AlertDialogHeader.displayName = "AlertDialogHeader"

const AlertDialogFooter = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...props} />
)
AlertDialogFooter.displayName = "AlertDialogFooter"

const AlertDialogTitle = (
  props: React.ComponentProps<typeof AlertDialogPrimitive.Title>,
) => <AlertDialogPrimitive.Title {...props} />
AlertDialogTitle.displayName = AlertDialogPrimitive.Title.displayName

const AlertDialogDescription = (
  props: React.ComponentProps<typeof AlertDialogPrimitive.Description>,
) => <AlertDialogPrimitive.Description {...props} />
AlertDialogDescription.displayName =
  AlertDialogPrimitive.Description.displayName

const AlertDialogAction = (
  props: React.ComponentProps<typeof AlertDialogPrimitive.Action>,
) => <AlertDialogPrimitive.Action {...props} />
AlertDialogAction.displayName = AlertDialogPrimitive.Action.displayName

const AlertDialogCancel = (
  props: React.ComponentProps<typeof AlertDialogPrimitive.Cancel>,
) => <AlertDialogPrimitive.Cancel {...props} />
AlertDialogCancel.displayName = AlertDialogPrimitive.Cancel.displayName

export {
  AlertDialog,
  AlertDialogPortal,
  AlertDialogOverlay,
  AlertDialogTrigger,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
}
